import * as R from "ramda";
import { getConcepts } from "./getConcepts.mjs";
import { parseNoDisplayAnnotation } from "./parseNoDisplayAnnotation.mjs";
const getTimePeriod = (structure) => {
  const timeDimension = R.pathOr(
    {},
    [
      "data",
      "dataStructures",
      0,
      "dataStructureComponents",
      "dimensionList",
      "timeDimensions",
      0
    ],
    structure
  );
  const timeDimensionConceptUrn = R.prop("conceptIdentity", timeDimension);
  if (R.isNil(timeDimensionConceptUrn)) {
    return null;
  }
  const concepts = getConcepts(structure);
  const timeDimensionConcept = R.prop(timeDimensionConceptUrn, concepts);
  const displayAnnotations = parseNoDisplayAnnotation(structure);
  const id = R.prop("id", timeDimension);
  return {
    id,
    label: R.prop("name")(timeDimensionConcept),
    display: R.not(R.has(id, displayAnnotations))
  };
};
export {
  getTimePeriod
};
